export default {
  ADMIN: 'admin',
  AGENT: 'agent',
  FLEET_MANAGER: 'fleet_manager',
  GFP: 'gfp',
  LAB: 'lab',
  SHIP: 'ship',
  SURVEYOR: 'surveyor',
  VESSEL_MANAGEMENT: 'vessel_management',
}
